/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrTriglyceridesTypename = "PhrTriglycerides" as const;

/**
 *
 * @export
 * @interface PhrTriglycerides
 */
export interface PhrTriglycerides {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrTriglycerides
   */
  other?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrTriglycerides
   */
  ultravioletVisibleAbsorptionSpectroscopy?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrTriglycerides
   */
  visibleAbsorptionSpectrophotometry?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrTriglycerides
   */
  readonly __typename?: string;
}

export function PhrTriglyceridesFromJSON(json: any): PhrTriglycerides {
  return PhrTriglyceridesFromJSONTyped(json, false);
}

export function PhrTriglyceridesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrTriglycerides {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrTriglyceridesTypename,

    other: !exists(json, "other") ? undefined : PhrMeasurementFromJSON(json["other"]),
    ultravioletVisibleAbsorptionSpectroscopy: !exists(json, "ultraviolet_visible_absorption_spectroscopy")
      ? undefined
      : PhrMeasurementFromJSON(json["ultraviolet_visible_absorption_spectroscopy"]),
    visibleAbsorptionSpectrophotometry: !exists(json, "visible_absorption_spectrophotometry")
      ? undefined
      : PhrMeasurementFromJSON(json["visible_absorption_spectrophotometry"]),
  };
}

export function PhrTriglyceridesToJSON(object?: PhrTriglycerides | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    other: PhrMeasurementToJSON(value.other),
    ultraviolet_visible_absorption_spectroscopy: PhrMeasurementToJSON(value.ultravioletVisibleAbsorptionSpectroscopy),
    visible_absorption_spectrophotometry: PhrMeasurementToJSON(value.visibleAbsorptionSpectrophotometry),
  };
}
